import { render, staticRenderFns } from "./PageEducatorInstitutionClassroomDashboard.vue?vue&type=template&id=d2adff56&scoped=true&"
import script from "./PageEducatorInstitutionClassroomDashboard.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionClassroomDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionClassroomDashboard.vue?vue&type=style&index=0&id=d2adff56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2adff56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VContainer,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
